import Vue from 'vue'
import Vuex from 'vuex'
import { TimeUtils } from './utils/timeUtils'
import { ApplicationState } from './application-state'
import { EventBus, GlobalEvents } from './event-bus'
import { RoundUtils } from './utils/roundUtils'
import { BonusType } from './utils/bonusType'
import { AppConstants } from './constants'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        appState: ApplicationState.LOADING_DATA,
        currentQuestionId: null,
        user: null,
        points: {
            prevRound: {
                loaded: false,
                points: null,
                position: null
            },
            month: {
                loaded: false,
                points: null,
                position: null
            },
            total: {
                loaded: false,
                points: null,
                position: null
            }
        },
        metadata: {
            userData: {
                liga: null,
                name: null,
                vlasnikLige: null,
                groupOwner: null,
                avatar: null,
                activeUserDevice: null,
                usedBonus_wild_card: false,
                usedBonus_times_three: false,
                usedBonus_plus_30_seconds: false
            },
            loaded: false,
            poweredBy: false,
            partners: []
        },
        round: {
            title: '',
            questions: [],
            startTime: 0,
            timeLength: 0,
            endTime: 0,
            activeQuestionId: null,
            quizKey: null
        },
        prevRound: { // previus round. may not be needed
            title: '',
            questions: [],
            startTime: 0,
            quizKey: ''
        },
        counters: { // These are reactive states for the Time Until Next round conter
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
        },
        timeDiff: 0,
        authenticated: false, // HANDLES firebase auth
        exampleRoundStatus: 0,
        exampleRoundQuestionId: null,
        exampleRoundAnswers: []
    },
    mutations: {
        // This method is run every second, triggered from App.vue
        // It will handle all counters on the site
        intervalCounter (state) {
            switch (state.appState) {
            case ApplicationState.ROUND_STARTING:
                state.counters = TimeUtils.secondsToTimeObject(TimeUtils.timeUntilFutureTimestamp(state.round.startTime))
                if (state.counters.seconds <= 0) {
                    state.appState = ApplicationState.ROUND_IN_PROGRESS
                    state.counters = TimeUtils.secondsToTimeObject(TimeUtils.timeUntilFutureTimestamp(state.round.endTime))
                }
                break
            case ApplicationState.ROUND_IN_PROGRESS:
                state.counters = TimeUtils.secondsToTimeObject(TimeUtils.timeUntilFutureTimestamp(state.round.endTime))
                state.currentQuestionId = RoundUtils.getCurrentQuestionId(state.round)
                if (state.counters.seconds <= 0) {
                    // Check for new round
                    this.commit('setPrevRound', state.round)
                    state.appState = ApplicationState.NO_FUTURE_ROUND
                    state.currentQuestionId = null
                    EventBus.$emit(GlobalEvents.ROUND_FINISHED)
                    state.counters = TimeUtils.secondsToTimeObject(TimeUtils.timeUntilFutureTimestamp(state.round.endTime + AppConstants.TIME_TO_TURN_IN))
                } else {
                    state.round.activeQuestionId = RoundUtils.getCurrentQuestionId(state.round)
                }
                break
            case ApplicationState.NO_FUTURE_ROUND:
                try {
                    if (state.currentQuestionId) {
                        state.currentQuestionId = RoundUtils.getCurrentQuestionId(state.round)
                    }
                    if (state.prevRound && state.prevRound.timeToTurnIn) {
                        state.counters = TimeUtils.secondsToTimeObject(TimeUtils.timeUntilFutureTimestamp(state.prevRound.endTime + state.prevRound.timeToTurnIn))
                    }
                } catch (error) {
                    state.currentQuestionId = null
                }
                // Hmmm, check for new round, subscribe to update on qIndex?
                break
            }
        },
        // Set time difference
        setTimeDiff (state, timeDiff) {
            state.timeDiff = timeDiff
        },
        // Set the Round data got from the firebase server
        setRound (state, round) {
            state.round.title = round.title
            state.round.endTime = round.endTime
            state.round.questions = round.questions
            state.round.startTime = round.startTime
            state.round.timeLength = round.timeLength
            state.round.quizKey = round.quizKey
            state.appState = ApplicationState.ROUND_STARTING
            state.counters = TimeUtils.secondsToTimeObject(TimeUtils.timeUntilFutureTimestamp(round.startTime))
        },

        setApplicationState (state, newApplicationState) {
            state.appState = newApplicationState
        },
        // Set the previous round data got from the firebase server
        setPrevRound (state, round) {
            state.prevRound.title = round.title
            state.prevRound.questions = round.questions
            state.prevRound.startTime = round.startTime
            state.prevRound.endTime = round.endTime
            state.prevRound.quizKey = round.quizKey
            state.prevRound.timeToTurnIn = AppConstants.TIME_TO_TURN_IN
        },
        setUsedBonusyType (state, bonusType) {
            switch (bonusType) {
            case BonusType.PLUS_30_SECONDS:
                state.metadata.userData.usedBonus_plus_30_seconds = true
                break
            case BonusType.WILD_CARD:
                state.metadata.userData.usedBonus_wild_card = true
                break
            case BonusType.TIMES_THREE:
                state.metadata.userData.usedBonus_times_three = true
                break
            }
        },
        setUser (state, user) {
            state.user = user
        },
        setUserDataVlasnikLige (state, vlasnikLige) {
            state.metadata.userData.vlasnikLige = vlasnikLige
        },
        setUserDataVlasnikGrupe (state, groupOwner) {
            state.metadata.userData.groupOwner = groupOwner
        },
        authorize (state) {
            state.authenticated = true
            setTimeout(() => {
                // TODO: REMOVE THIS
                EventBus.$emit(GlobalEvents.ROUND_FINISHED)
            }, 250)
        },
        deauthorize (state) {
            state.authenticated = false
        }
    },
    getters: {
        round: state => state.round
    },
    actions: {
        authorize ({ commit }) {
            commit('authorize')
        },
        deauthorize ({ commit }) {
            commit('deauthorize')
        }
    }
})
